// ── DueCount — «на сегодня» одним взглядом ───────────────────────────────────
// Зелёным — к повторению (уже пройденные карточки, которым пора), синим — новые.
// Одна и та же пара цветов везде: боковое меню, нижняя панель, главная, раздел
// «Повторение», конец подхода. Нулевая часть не показывается.
//
// variant:
//   'text'  — два числа в строке (боковое меню, подписи);
//   'pill'  — плашка из двух половин на значке (нижняя панель, узкое меню);
//   'words' — «13 к повторению · 9 новых» в подписях.

import { readableOn } from './color';
import { t } from '../i18n';

const cap = (n, max) => (n > max ? `${max}+` : String(n));

export function dueLabel(repeat, fresh) {
  return t("К повторению: {0}, новых: {1}", [repeat, fresh]);
}

export default function DueCount({ C, repeat = 0, fresh = 0, variant = 'text', max = 999 }) {
  if (repeat <= 0 && fresh <= 0) return null;
  const parts = [
    repeat > 0 && { key: 'r', n: repeat, color: C.green },
    fresh > 0 && { key: 'f', n: fresh, color: C.blue, text: C.blueDark },
  ].filter(Boolean);

  if (variant === 'pill') {
    return (
      <span role="img" aria-label={dueLabel(repeat, fresh)} title={dueLabel(repeat, fresh)}
        style={{ display: 'inline-flex', height: 18, borderRadius: 9, overflow: 'hidden', boxShadow: `0 0 0 2px ${C.pageBg}`,
          fontSize: 10.5, fontWeight: 700, lineHeight: '18px', fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
        {parts.map((p) => (
          <span key={p.key} style={{ minWidth: 18, padding: '0 5px', textAlign: 'center', background: p.color, color: readableOn(p.color) }}>
            {cap(p.n, max)}
          </span>
        ))}
      </span>
    );
  }

  if (variant === 'words') {
    // «13 к повторению · 9 новых» — числа в своих цветах, слова обычным текстом.
    const word = [
      repeat > 0 && <span key="r"><b style={{ color: C.green, fontVariantNumeric: 'tabular-nums' }}>{repeat}</b> {t("к повторению")}</span>,
      fresh > 0 && <span key="f"><b style={{ color: C.blueDark, fontVariantNumeric: 'tabular-nums' }}>{fresh}</b> {t("новых")}</span>,
    ].filter(Boolean);
    return <span>{word.reduce((acc, el, i) => (i ? [...acc, ' · ', el] : [el]), [])}</span>;
  }

  return (
    <span aria-label={dueLabel(repeat, fresh)} title={dueLabel(repeat, fresh)}
      style={{ display: 'inline-flex', alignItems: 'baseline', gap: 6, fontWeight: 600, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
      {parts.map((p) => (
        <span key={p.key} style={{ color: p.text || p.color }}>{cap(p.n, max)}</span>
      ))}
    </span>
  );
}
